











































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'

@Component
export default class ViewInicio extends Vue {
  login() {
    Auth.login('/')
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie

      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
  }

  mounted() {
    // Verificar se há sessão OIDC válida (checar ambos os formatos de chave)
    const legacyAuthKey = `oidc.user:${(window as any).API_FINX_AUTH}:portal-client-2`
    const keycloakUrl = (window as any).KEYCLOAK_AUTHORITY_URL || (window as any).API_FINX_AUTH
    const realm = (window as any).KEYCLOAK_REALM || 'finx'
    const clientId = (window as any).KEYCLOAK_CLIENT_ID || 'finx-front'
    const newAuthKey = `oidc.user:${keycloakUrl}/realms/${realm}:${clientId}`
    const hasAuth = !!(localStorage.getItem(legacyAuthKey) || localStorage.getItem(newAuthKey))

    const isImpersonating = sessionStorage.getItem('IMPERSONATION_ACTIVE')

    if (isImpersonating === 'true') {
      if (hasAuth) {
        // Sessão de personificação ativa — redirecionar para o app
        let redirectUrl = '/perfil'
        if (this.$user && this.$user.profile) {
          if (this.$user.profile.defaultPage && this.$user.profile.defaultPage.view) {
            redirectUrl = `/${this.$user.profile.defaultPage.view}`
          } else if (this.$user.profile.pageAuthorized && this.$user.profile.pageAuthorized.length > 0) {
            redirectUrl = `/${this.$user.profile.pageAuthorized[0]}`
          }
        }
        this.$router.push(redirectUrl)
        return
      } else {
        // Sessão de personificação já encerrada — limpar flags para liberar o login
        sessionStorage.removeItem('IMPERSONATION_ACTIVE')
        sessionStorage.removeItem('IMPERSONATION_USER')
        sessionStorage.removeItem('IMPERSONATION_IN_PROGRESS')
        sessionStorage.removeItem('IMPERSONATION_REDIRECT')
      }
    }

    this.deleteAllCookies()
    try {
      if (!hasAuth) {
        // Preservar postLoginUrl para que o redirecionamento pós-login funcione
        const postLoginUrl = localStorage.getItem('postLoginUrl')
        localStorage.clear()
        sessionStorage.clear()
        if (postLoginUrl) {
          localStorage.setItem('postLoginUrl', postLoginUrl)
        }
      }
    } catch (e) {
      // fallback: se qualquer erro, evite apagar storage inadvertidamente
    }
  }
}
